'use strict';

module.exports = [
    {
        code: 'nurse_care_manager',
        value: 'nurse_care_manager',
        label: 'Nurse Care Manager'
    },
    { code: 'social_worker', value: 'social_worker', label: 'Social Worker' },
    { code: 'chaplain', value: 'chaplain', label: 'Chaplain' },
    { code: 'nutritionist', value: 'nutritionist', label: 'Nutritionist' },
    {
        code: 'enrollment_review',
        value: 'enrollment_review',
        label: 'Enrollment Review, RN'
    },
    {
        code: 'physical_therapist',
        value: 'physical_therapist',
        label: 'Physical Therapist'
    },
    {
        code: 'care_coordinator',
        value: 'care_coordinator',
        label: 'Care Coordinator'
    },
    {
        code: 'nurse_practitioner',
        value: 'nurse_practitioner',
        label: 'Nurse Practitioner'
    },
    {
        code: 'medical_director',
        value: 'medical_director',
        label: 'Medical Director'
    },
    {
        code: 'executive_director',
        value: 'executive_director',
        label: 'Executive Director'
    },
    {
        code: 'triage_enrollment_nurse',
        value: 'triage_enrollment_nurse',
        label: 'Enrollment Specialist'
    },
    { code: 'administrator', value: 'administrator', label: 'Administrator' },
    {
        code: 'administrative_support',
        value: 'administrative_support',
        label: 'Administrative Support'
    },
    {
        code: 'broker_access',
        value: 'broker_access',
        label: 'Broker Access'
    },
    {
        code: 'csr_agent',
        value: 'csr_agent',
        label: 'CSR Agent'
    }
];
